<template>
  <div>
 <div class="loading" :style="loadingAnim">
      <div class="lds-ripple">
        <div></div>
        <div></div>
      </div>
    </div>
  <app-login></app-login>

</div>
</template>

<script>
import Login from "../components/Login/login"
export default {
  components:{
    appLogin:Login
  },
  computed:{
      loadingAnim() {
        if (this.$store.state.loadAnimAc) {
          return {
            display: "block"
          }
        } else {
          return {
            display: "none"
          }
        }
      }
  }
}
</script>

<style>
 
  @import url('https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue